import { useRoutes } from "react-router-dom";
import { templateEditorRoutes } from "./routes";

interface Props {
	modulePath: string;
	module: string;
}

export default function TemplateEditorRouter({ modulePath, module }: Props) {
	return useRoutes(templateEditorRoutes(modulePath, module));
}
